import React from "react";
import { DocumentData, DocumentSnapshot } from "firebase/firestore";
import { Button, Icon, Spinner } from "native-base";
import { Feather } from "@expo/vector-icons";
import {
  dragActiveStyle,
  useUploadPhotoToObject,
} from "../../../hooks/useUploadPhotoToObject";

type Props = {
  object: DocumentSnapshot<DocumentData>;
};

export default function SignatureProofUpload({ object }: Props) {
  const projectId = object.ref.parent.parent!.id;
  const objectId = object.id;

  const [uploadPhoto, isUploading, dropzone] = useUploadPhotoToObject(
    "signatureProof",
    projectId,
    objectId
  );

  const { getRootProps, isDragAccept } = dropzone;

  return (
    <div {...getRootProps()} style={dragActiveStyle(isDragAccept)}>
      <Button
        startIcon={
          isUploading ? <Spinner /> : <Icon as={Feather} name="upload" />
        }
        onPress={uploadPhoto}
        isDisabled={isUploading}
      >
        Foto hochladen
      </Button>
    </div>
  );
}
